import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState = {
  isOpenWarningStatus: true,
  isOpenOrderConfirmationBanner: true,
  isOpenShippingMinimumOrderBanner: true,
  isOpenDeliveryMinimumOrderBanner: true,
  isOpenAddPostalCodeBanner: true,
  isOpenNoValidPostalCodeBanner: true,
  isOpenCustomRadiusBanner: true,
  isOpenLanguageTableInstructionBanner: true,
  isOpenChangeDeliveryLabelIntructionBanner: true,
  isOpenDisplayDatePickerInstructionBanner: true,
  isOpenDateAndTimeFormatInstructionBanner: true,
  isOpenHolidayBanner: true,
  isOpenOrderInforBanner: true,
  isOpenDashboardInstructionSchedulingWidget: true,
};

export const bannerSlice = createSlice({
  name: 'banner',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    handleVisibleBanner: (
      state,
      action: PayloadAction<{
        key: keyof typeof initialState;
        value: boolean;
      }>,
    ) => {
      state[action.payload.key] = action.payload.value;
    },
  },
});

export const isOpenWarningStatusSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenWarningStatus,
);

export const isOpenOrderConfirmationBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenOrderConfirmationBanner,
);

export const isOpenShippingMinimumOrderBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenShippingMinimumOrderBanner,
);

export const isOpenDeliveryMinimumOrderBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenDeliveryMinimumOrderBanner,
);

export const isOpenAddPostalCodeBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenAddPostalCodeBanner,
);

export const isOpenNoValidPostalCodeBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenNoValidPostalCodeBanner,
);

export const isOpenCustomRadiusBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenCustomRadiusBanner,
);

export const isOpenDisplayDatePickerInstructionBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenDisplayDatePickerInstructionBanner,
);

export const isOpenDateAndTimeFormatInstructionBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenDateAndTimeFormatInstructionBanner,
);

export const isOpenLanguageTableInstructionBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenLanguageTableInstructionBanner,
);

export const isOpenChangeDeliveryLabelIntructionBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenChangeDeliveryLabelIntructionBanner,
);

export const isOpenHolidayBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenHolidayBanner,
);

export const isOpenOrderInforBannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenOrderInforBanner,
);

export const isOpenDashboardInstructionSchedulingWidgetSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state.isOpenDashboardInstructionSchedulingWidget,
);


export const { handleVisibleBanner } = bannerSlice.actions;

export default bannerSlice;
